import { connect } from 'react-redux';
import DonationFailure from '../components/DonationFailure';


const mapStateToProps = state => ({
  error: state.error
});

export default connect(mapStateToProps)(DonationFailure);



/** WEBPACK FOOTER **
 ** ./src/containers/DonationFailureContainer.jsx
 **/